import { BACKOFFICE, HTTP } from '@/services/HTTPService';
import store from '@/store'

export default {
  async getM1List() {
    try {
      const response = await BACKOFFICE.get(
        "/staff_list/?staff_type=m1"
      );
      return response.data;
    } catch (err) {
      if (err.response.status === 404) {
        return [];
      }
    }
  },
  async getM1Status(dateTime) {
    const segmentState = store.state.user.segment;
    const params = {
      date_time: dateTime,
      tz_offset: segmentState.tz_offset,
      segment: segmentState.id,
    };
    const response = await HTTP.get("/m1/status/", { params });
    return response.data;
  },
}
